/**
 * Time Slots icon: clock with recurrence/refresh arrow.
 * Uses the provided scheduling icon image.
 */
export default function TimeSlotsIcon({ size = 20, style = {} }) {
  return (
    <img
      src="/icons/time-slots-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain', imageRendering: '-webkit-optimize-contrast', ...style }}
    />
  );
}
